import { render, staticRenderFns } from "./ViewAllOrders.vue?vue&type=template&id=15af292a&scoped=true&"
import script from "./ViewAllOrders.vue?vue&type=script&lang=js&"
export * from "./ViewAllOrders.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllOrders.vue?vue&type=style&index=0&id=15af292a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15af292a",
  null
  
)

export default component.exports